import { styled } from '@mui/material/styles';
import { Button, Icon } from '@mui/material';

// Outer wrapper container. Encapsulates the form-level styling via nested
// stable class names that the Form/DropZone components emit (or that we pass
// as className strings below).
export const InfoContainer = styled('div', {
  shouldForwardProp: (prop) => !['isMobile', 'printView'].includes(prop),
})(({ theme, isMobile, printView }) => ({
  position: 'relative',
  padding: printView ? `0 ${theme.spacing(isMobile ? 2 : 4)}` : theme.spacing(isMobile ? 2 : 4),

  // Targets the Form's formStyle prop (formStyle class string defined below)
  '& .info-form-style': {
    alignItems: 'flex-start !important',
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',
    padding: '15px 0',
    '& .screenWrapper': {
      width: printView ? '100%' : undefined,
      ...(printView && { gap: theme.spacing(2) }),
      [theme.breakpoints.up('sm')]: {
        flexDirection: printView ? 'row' : 'column',
      },
    },
  },

  '& .info-print-column': {
    flex: '1 1 0',
    minWidth: 0,
    boxSizing: 'border-box',
  },

  '& .info-screen-container-mobile': {
    maxWidth: 'none !important',
  },

  '& .info-access-container': {
    width: isMobile ? 'auto' : '100%',
    padding: theme.spacing(2),
  },

  '& .info-screen-width': {
    marginRight: theme.spacing(2),
  },

  '& .info-drop-zone': {
    border: `1px solid ${theme.palette.divider} !important`,
    borderRadius: `4px  !important`,
    minHeight: 'auto !important',
    backgroundColor: 'transparent !important',
    '&:hover': {
      border: `1px solid ${theme.palette.text.primary} !important`,
    },
    '& p': {
      fontSize: '14px !important',
      textAlign: 'left !important',
      padding: `${theme.spacing(1)} ${theme.spacing(2)} !important`,
    },
    '& > div > svg': {
      display: 'none !important',
    },
  },
}));

export const ButtonContainer = styled('div')({
  maxWidth: 1000,
  margin: '0 auto 10px',
});

export const DropIcon = styled(Icon)(({ theme }) => ({
  position: 'absolute',
  right: 9,
  top: 17,
  color: theme.palette.primary.main,
}));

export const DeleteButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

// Class-name string constants for the Form/DropZone props that take strings
export const INFO_FORM_STYLE = 'info-form-style';
export const INFO_SCREEN_CONTAINER = '';
export const INFO_SCREEN_CONTAINER_MOBILE = 'info-screen-container-mobile';
export const INFO_ACCESS_CONTAINER = 'info-access-container';
export const INFO_DROP_ZONE = 'info-drop-zone';
export const INFO_SCREEN_WIDTH = 'info-screen-width';
export const INFO_PRINT_COLUMN = 'info-print-column';
